import { FLAG_DEFAULTS, type FeatureFlag } from '../types'

export type FeatureFlagValues = Partial<Record<FeatureFlag, boolean>>

const isFlag = (k: string): k is FeatureFlag => k in FLAG_DEFAULTS

/*
|--------------------------------------------------------------------------
| Build-time flag values
|--------------------------------------------------------------------------
|
| `VITE_FEATURE_FLAGS` turns flags on or off for a deployment without a
| code change, e.g. `VITE_FEATURE_FLAGS=onboarding:on,building-address:off`.
| A bare name means on. Unknown names are ignored, so a typo falls back to
| the safe default in FLAG_DEFAULTS rather than enabling anything.
*/
export function parseFlagList(raw: string | undefined): FeatureFlagValues {
  const flags: FeatureFlagValues = {}
  if (!raw) return flags

  for (const part of raw.split(',')) {
    const [key, state] = part.trim().split(':')
    if (!isFlag(key)) continue
    flags[key] = state === undefined || state === 'on' || state === 'true'
  }

  return flags
}

export function readEnvFlags(): FeatureFlagValues {
  return parseFlagList(import.meta.env.VITE_FEATURE_FLAGS)
}
